import React, { useEffect, useState } from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import { useSelector } from "react-redux";
import Select from "react-select";
import {
  Dropdown,
  DropdownIndicator,
  formatOptionLabel,
} from "../../common/ContractsSelect/common/components";
import { client } from "../../../App";
import { LIST_CONTRACTS } from "../../../helpers/queries";
import { handlerErrors } from "../../../helpers/helpers";
import Modal from "../../common/Modal/Modal";
import "./ContractSelectWithRemoteOptionsField.scss";
import "./SelectSearch.scss";
export default function ContractSelectField(props) {
  const [isKeyboard, setIsKeyboard] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        setIsKeyboard(true);
      } else if (e.key === "Tab") {
        setIsKeyboard(false);
      }
    };

    const handleMouseMove = () => {
      setIsKeyboard(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const CustomMenuList = (props) => {
    const { innerRef, innerProps, children, selectProps } = props;

    return (
      <ul
        id={selectProps.menuId || "contract-list"}
        className="contract-list"
        role="listbox"
        ref={innerRef}
        {...innerProps}
      >
        {children}
      </ul>
    );
  };

  const CustomOption = (props) => {
    const { innerRef, innerProps, isFocused, data, children } = props;
    return (
      <li
        ref={innerRef}
        role="option"
        aria-selected={value?.id === data?.id}
        {...innerProps}
        className={[
          "custom-option",
          isFocused && isKeyboard ? "is-focused" : "",
          value?.id === data?.id ? "selected-contract-field" : "",
        ]
          .join(" ")
          .trim()}
      >
        {children ?? data.label}
      </li>
    );
  };

  let {
    name,
    label,
    placeholder,
    loading,
    noContractFound,
    onSelected,
    contractSelected,
    startEventDataLayer,
    excludeStatusTypes = [],
    validationSchema,
    ...rest
  } = props;
  const [field, meta, helper] = useField(props);
  const { summaryMode } = rest;
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  const getProperLabel = (field) => {
    let properLabel = field;
    if (typeof field === "object" && field.props && field.props.i18nKey) {
      properLabel = t(field.props.i18nKey);
    }
    return properLabel;
  };

  if (!loading) {
    loading = "Loading";
  }

  if (!noContractFound) {
    noContractFound = "No contract found";
  }

  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const { list, current } = useSelector((state) => state.contracts);
  const [contracts, setContracts] = useState([]);
  const [infoModal, setInfoModal] = useState({ active: false, type: null });

  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const { t } = useTranslation();
  const [value, setValue] = useState(null);
  const [currentContractData, setCurrentContractData] = useState([]);
  const [, setGenericError] = useState(null);
  const [isSentDataLayer, setIsSentDataLayer] = useState(false);

  useEffect(() => {
    const l = list
      .filter((item) => !excludeStatusTypes.includes(item.state))
      .map((contract) => {
        return {
          name: contract.name || "",
          id: contract.id || "",
          state: contract.state || "",
          clientId: contract.clientId || "",
        };
      });
    setOptions(l);
  }, [list, excludeStatusTypes]);

  useEffect(() => {
    if (current && current.id && contractSelected === "current") {
      triggerUpdated(current.id);
    }
    // eslint-disable-next-line
  }, [current, contractSelected]);
  useEffect(() => {
    if (props.name === "selezioneContrattoTutela") {
      const listContracts = async () =>
        client().query({
          query: LIST_CONTRACTS,
        });

      listContracts()
        .then(({ data }) => {
          if (data.listContracts.pagination.totalElements) {
            const formated = data.listContracts.elements.map(
              ({
                contractId,
                serviceOnlineBill,
                serviceLoanLossProvisions,
              }) => {
                return {
                  contractId: contractId || "",
                  serviceOnlineBill: serviceOnlineBill.enabled || false,
                  serviceLoanLossProvisions:
                    serviceLoanLossProvisions.enabled || false,
                };
              }
            );
            setContracts(formated);
          } else {
            setGenericError(t("contract.noContractFound"));
          }
        })
        .catch((err) => {
          handlerErrors(err, setGenericError, setGenericError);
        });
      listContracts()
        .then(({ data }) => {
          if (data.listContracts.pagination.totalElements) {
            const formatedTutela = data.listContracts.elements
              .filter(
                (element) => element.serviceLoanLossProvisions.enabled === false
              )
              .map(({ contractId }) => {
                return {
                  contractId: contractId,
                };
              });
            const l = list
              .filter(
                (item) =>
                  !excludeStatusTypes.includes(item.state) &&
                  formatedTutela.find(
                    (contract) => contract.contractId === item.id
                  )
              )
              .map((contract) => {
                return {
                  name: contract.name || "",
                  id: contract.id || "",
                  state: contract.state || "",
                  clientId: contract.clientId || "",
                };
              });
            setOptions(l);
          } else {
            setGenericError(t("contract.noContractFound"));
          }
        })
        .catch((err) => {
          handlerErrors(err, setGenericError, setGenericError);
        });
    } else if (props.name === "selezioneContratto") {
      const listContractsDomiciliazione = async () =>
        client().query({
          query: LIST_CONTRACTS,
        });
      listContractsDomiciliazione()
        .then(({ data }) => {
          if (data.listContracts.pagination.totalElements) {
            const formatedDomiciliazione = data.listContracts.elements
              .filter(
                (element) => element.serviceBankDomiciliation.enabled === false
              )
              .map(({ contractId }) => {
                return {
                  contractId: contractId,
                };
              });
            const l = list
              .filter(
                (item) =>
                  !excludeStatusTypes.includes(item.state) &&
                  formatedDomiciliazione.find(
                    (contract) => contract.contractId === item.id
                  )
              )
              .map((contract) => {
                return {
                  name: contract.name || "",
                  id: contract.id || "",
                  state: contract.state || "",
                  clientId: contract.clientId || "",
                };
              });
            setOptions(l);
          } else {
            setGenericError(t("contract.noContractFound"));
          }
        })
        .catch((err) => {
          handlerErrors(err, setGenericError, setGenericError);
        });
    }
  }, [props.name, t, list, excludeStatusTypes]);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };
  const triggerUpdated = (selected) => {
    const currentSelectedContract = list.find((item) => item.id === selected);
    if (startEventDataLayer && !isSentDataLayer) {
      startEventDataLayer();
      setIsSentDataLayer(true);
    }

    if (onSelected) {
      onSelected(
        currentSelectedContract,
        values,
        setFieldValue,
        setFieldTouched
      );
    }
    setIsOpen(false);
    helper.setValue(selected);
    setValue(currentSelectedContract);
    if (props.name === "selezioneContrattoTutela") {
      setCurrentContractData(currentSelectedContract);
      setInfoModal({ active: true, type: "TUTELA" });
    }
  };
  const renderInfoModal = () => {
    if (infoModal.type === "TUTELA") {
      return (
        <div className="no-close">
          <Modal
            show={true}
            onClose={() => setInfoModal({ active: false, type: null })}
            descriptionClass={"active-section"}
            description=
              {contracts.filter(i => i.contractId === currentContractData.id)[0].serviceOnlineBill === false && contracts.filter(i => i.contractId === currentContractData.id)[0].serviceLoanLossProvisions === false ? <span className="sp-text">
                {t("tutela.perdite.enabled.modal")}
              </span> : (contracts.filter(i => i.contractId === currentContractData.id)[0].serviceOnlineBill === true && contracts.filter(i => i.contractId === currentContractData.id)[0].serviceLoanLossProvisions === false ? <span className="sp-text">
                {t("bolleta.online.enabled.modal")}
              </span> : (contracts.filter(i => i.contractId === currentContractData.id)[0].serviceLoanLossProvisions === true ? <p>{t("info_message_tutela_perdite")}</p> : null))
              }
          />
        </div>
      );
    }
  };

  const filterOption = (candidate, input) => {
    if (input) {
      return Object.values(candidate.data).some((item) => {
        if (!item) {
          return false;
        }
        return (
          item.indexOf(input) !== -1 || item.indexOf(input.toUpperCase()) !== -1
        );
      });
    }
    return true;
  };

  return (
    <Form.Group className={meta.touched && meta.error ? "has-error contract-select-field" : "contract-select-field"}>

      {!summaryMode ? (
        <>
          <div>
            {label && (
              <Form.Label className="paragraph-small-fs9" htmlFor={field.name}>
                {getProperLabel(label)}
              </Form.Label>
            )}
          </div>
          {props.name === "selezioneContrattoTutela" ? renderInfoModal() : null}
          <Dropdown
            isOpen={isOpen}
            id={field.name + "-dropdown"}
            onClose={toggleOpen}
            aria-expanded={isOpen}
            target={
              <div
                className={`form-control select-remote-options dropdown ${isOpen} ${(meta.touched && meta.error) ? "is-invalid" : ""}`}
              >
                <button
                  onClick={toggleOpen}
                  className={
                    meta.touched && meta.error
                      ? "btn btn-contract-select btn-default  select-contracts select-error"
                      : "btn btn-contract-select btn-default  select-contracts"
                  }
                  type="button"
                >
                  {value && value.state ? (
                    <>
                      <span className={"font-bold badge badge--" + value.state}>
                        {t(`contract.select.state.${value.state}`)}
                      </span>
                      <span className="button-text">{value.name}</span>
                      <span className="gc-icon-functional-chevron-down contract-select-icon" />
                    </>
                  ) : (
                    <>
                      <span className="button-text">
                        {!(current && list)
                          ? getProperLabel(loading)
                          : options.length > 0
                          ? getProperLabel(placeholder)
                          : getProperLabel(noContractFound)}
                      </span>
                      <span className="gc-icon-functional-chevron-down contract-select-icon" />
                    </>
                  )}
                </button>
              </div>
            }
          >
            <Select
              autoFocus
              backspaceRemovesValue={false}
              value={value}
              formatOptionLabel={formatOptionLabel}
              options={options}
              components={{
                DropdownIndicator,
                IndicatorSeparator: null,
                MenuList: CustomMenuList,
                Option: CustomOption,
              }}
              controlShouldRenderValue={false}
              hideSelectedOptions={false}
              isClearable={false}
              menuIsOpen
              onChange={(data) => triggerUpdated(data.id)}
              className={(meta.touched && meta.error) ? "gcap-select form-control is-invalid" : "gcap-select form-control"}
              isDisabled={options.length <= 0}
              placeholder={
                options.length > 0
                  ? "Scegli un contratto"
                  : "Nessun contratto disponibile"
              }
              filterOption={filterOption}
              tabSelectsValue={false}
              aria-describedby={
                meta.touched && meta.error ? field.name + "-error" : null
              }
              required={isRequired}
              id={field.name}
            />
          </Dropdown>

          {meta.touched && meta.error && (
            <p
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </p>
          )}
        </>
      ) : (
        <>
          {label && (
            <span className="paragraph-small-fs9">
              {getProperLabel(label)}
            </span>
          )}
          <SummaryItem value={field.value} error={meta.error} />
        </>
      )}
    </Form.Group>
  );
}
